import React, { useState } from "react";

import Settings from "./settings/Settings";
import GameRules from "./gameRules/GameRules";
import History from "./history/History";
import ProvFair from "./provFair/ProvFair";
import SelectMines from "./selectMines/SelectMines";
import SetBet from "./setBet/SetBet";
import AutoConfig from "./autoRoll/AutoConfig";
import BetReply from "./betReply/BetReply";

export default ({
  bet,
  userInfo,
  userId,
  bombs,
  provablyFair,
  history,
  autoConfigs,
  Globals,
  above,
  aboveAnim,
  aboveSetting,
  handleAbove,
  handleAboveAnim,
  handleSetting,
  aboveSettingAnim,
  handleNotification,
  notifyText,
  handleBombs,
  handleBetAmount,
  handleAutoSelect,
  handleAutoRollLogic,
  saveMines,
  saveBet,
  isClickable,
  isAutoOn,
  floorFigure,
  userSettings,
  saveUserSettings,
  getBetReply,
  betReply,
  handleVolumeLocal,
  explosion,
  audio,
}) => {
  const [settingsA, setSettignsA] = useState(false);
  const [roundID, setRoundID] = useState("");

  const handleRoundID = (i) => setRoundID(i);
  const handleSettingsOut = (e) => {
    setSettignsA(true);
  };

  return (
    <>
      {aboveSetting === "settings" && (
        <Settings
          handleAbove={handleAbove}
          handleAboveAnim={handleAboveAnim}
          aboveAnim={aboveAnim}
          aboveSettingAnim={aboveSettingAnim}
          handleSetting={handleSetting}
          settingsA={settingsA}
          handleSettingsOut={handleSettingsOut}
          userSettings={userSettings}
          saveUserSettings={saveUserSettings}
          handleVolumeLocal={handleVolumeLocal}
          audio={audio}
        />
      )}
      {above === "gameRules" && (
        <GameRules
          handleAbove={handleAbove}
          handleAboveAnim={handleAboveAnim}
          handleSettingsOut={handleSettingsOut}
          aboveAnim={aboveAnim}
          audio={audio}
          userInfo={userInfo}
        />
      )}
      {above === "history" && (
        <History
          handleAbove={handleAbove}
          handleAboveAnim={handleAboveAnim}
          handleSettingsOut={handleSettingsOut}
          aboveAnim={aboveAnim}
          history={history}
          floorFigure={floorFigure}
          userId={userId}
          getBetReply={getBetReply}
          betReply={betReply}
          handleNotification={handleNotification}
          handleRoundID={handleRoundID}
          audio={audio}
          userInfo={userInfo}
        />
      )}
      {above === "provFair" && (
        <ProvFair
          pf={provablyFair}
          Globals={Globals}
          handleAbove={handleAbove}
          notifyText={notifyText}
          handleNotification={handleNotification}
          isClickable={isClickable}
          isAutoOn={isAutoOn}
          handleAboveAnim={handleAboveAnim}
          aboveAnim={aboveAnim}
          handleSettingsOut={handleSettingsOut}
          userSettings={userSettings}
          audio={audio}
        />
      )}
      {above === "selectMines" && (
        <SelectMines
          handleAbove={handleAbove}
          handleAboveAnim={handleAboveAnim}
          aboveAnim={aboveAnim}
          handleBombs={handleBombs}
          bombs={bombs}
          saveMines={saveMines}
          audio={audio}
        />
      )}
      {above === "setBet" && (
        <SetBet
          handleAbove={handleAbove}
          handleAboveAnim={handleAboveAnim}
          aboveAnim={aboveAnim}
          bet={bet}
          userInfo={userInfo}
          handleBetAmount={handleBetAmount}
          handleNotification={handleNotification}
          notifyText={notifyText}
          userSettings={userSettings}
          audio={audio}
        />
      )}

      {above === "autoConfig" && (
        <AutoConfig
          handleAbove={handleAbove}
          handleAboveAnim={handleAboveAnim}
          aboveAnim={aboveAnim}
          bet={bet}
          userInfo={userInfo}
          handleAutoSelect={handleAutoSelect}
          handleAutoRollLogic={handleAutoRollLogic}
          handleBombs={handleBombs}
          handleNotification={handleNotification}
          autoConfigs={autoConfigs}
          bombs={bombs}
          saveBet={saveBet}
          floorFigure={floorFigure}
          userSettings={userSettings}
          audio={audio}
        />
      )}
      {above === "betReply" && (
        <BetReply
          handleAbove={handleAbove}
          notifyText={notifyText}
          handleAboveAnim={handleAboveAnim}
          aboveAnim={aboveAnim}
          betReply={betReply}
          precision={userInfo.precision}
          floorFigure={floorFigure}
          explosion={explosion}
          handleNotification={handleNotification}
          roundID={roundID}
          audio={audio}
        />
      )}
    </>
  );
};
